export default function Divide() {
    return (
        <div className="alli-w-full alli-border-b alli-border-gray-400"></div>
    );
}
